export default function DisplayConnectionInfo({currentAccount}){
    let obj = {
        1: "Mainnet",
        42: "Kovan",
        3: "Ropsten",
        4: "Rinkeby",
        5: "Goerli"
    }
    if(window.ethereum){
          if(currentAccount===""){
            return <div className="connect">Please connect Wallet to mint NFT.</div>
          }else{
            let version = window.ethereum.networkVersion;
            if(version==="4"){
                return <div className="connect" style={{background:'green',color:'white'}}> Connected to rinkeby testnet</div>
            }else{
                return <div className="connect">You are connected to {(version in obj)?(obj[version]+" Network"):"some other network"}. Please connect to Rinkeby  testnet to mint NFT.</div>
            }
        }
    }
    else{
        return <div className="connect">Get Metamask to mint NFT</div>
    }
}